import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAccount } from 'queries/accounts/useAccount';
import { saudiRewardsRetroRedeemUserQuery } from 'queries/saudi-rewards-retro-redeem/queries';
import { isNotFound } from 'queries/tickets/utils';

import LoadingScreen from 'components/@common/LoadingScreen';
import Page404 from 'components/@screens/Page404';

import ClaimPointsFlow from './ClaimPointsFlow';
import { useSessionRedeemToken } from './hooks';

const SaudiRewardsRedeemContainer = () => {
  const redeemToken = useSessionRedeemToken();
  const { isReady } = useRouter();
  const { account, isLoading: isAccountLoading } = useAccount();
  const { data, isLoading, error } = useQuery({
    ...saudiRewardsRetroRedeemUserQuery({ redeemToken }),
    enabled: !!redeemToken,
  });

  // If the user never created an account this will be empty
  const redemptionUser = data?.saudiRewardsRetroRedeemUser;

  if ((!redeemToken && !isLoading && isReady) || (error && isNotFound(error))) {
    return <Page404 />;
  }

  if (isLoading || !isReady || !redemptionUser || isAccountLoading) {
    return <LoadingScreen />;
  }

  const showDifferentAccountWarning =
    account && account.email !== redemptionUser?.redeemEmail;

  return (
    <ClaimPointsFlow
      saudiRewardsMemberId={account?.saudiRewardsMemberId}
      redeemEmail={redemptionUser?.redeemEmail}
      userExists={!!redemptionUser?.existingAccount}
      mismatchedEmail={!!showDifferentAccountWarning}
    />
  );
};

export default SaudiRewardsRedeemContainer;
